import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import { useEffect, useState } from "react";
import { IMajorTech } from "../../models/MajorTech";
import { Search } from "../../shared/Search";
import { Fetch } from "../../shared/Fetch";
import React from 'react';
import { IModel } from "./PipelineStatus";
import { ILogin, IPermissionProps } from "../../models/Login";

import { Dialog } from "primereact/dialog";
import { format } from "date-fns";
import { IPipelineStatus } from "./IPipelineStatus";
import { SubCategoryStatus } from "./SubcategoryStatus";
import { EmptyPipelineStatus } from "./EmptyPipelineStatus";


interface Iprops {
    open: boolean | undefined;
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps
}



export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const [openForm, setOpenForm] = useState({ singledata: {}, open: false } as { singledata: any, open: boolean });



    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    useEffect(() => {
        loadTableData();
    }, [globalFilter, props.reload]);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Pipeline_Status_Mast", "GET", null, `search=${globalFilter}`, props.toast);
        if (response) {
            const data: Array<any> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyPipelineStatus });
    };


    const openEdit = (rowDatauser: IPipelineStatus) => {
     props.setModal({ open: true, singleData: rowDatauser });
    };

    

    const openSubCategoryForm = (rowDatauser: IPipelineStatus) => {
        setOpenForm({ singledata: rowDatauser, open: true });
    }

    const leftToolbarTemplate = () => {

        return (
            <React.Fragment>
               <div className="my-2">
                   <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div> : <div></div>
            </React.Fragment>
        );
    };

    const hideHistory = () => {
        setOpenForm({ singledata: {}, open: false });
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0"> Pipeline Status</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalFilter} />
            </span>
        </div>
    );


    const actionBodyTemplate = (rowData: IPipelineStatus) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil text-primary" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
                {rowData.isSubCategory  && <Button icon="pi pi-plus" className="p-button-rounded p-button-success bg-primary mr-1" onClick={() => openSubCategoryForm(rowData)} />}
            </div>
        );
    };

    return (
        <>
            <Toolbar className="mb-1 py-0"  left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                value={tableData.tableData}
                emptyMessage="No Data found."
                header={header}
                loading={tableData.loading}
            >
                <Column field="status_Name" header="Status Name" />
                <Column body={actionBodyTemplate} />
            </DataTable>
            <SubCategoryStatus permissions={props.permissions} open={openForm.open} singledata={openForm.singledata} toast={props.toast} hideHistory={hideHistory}  />

        </>
    );
}
